// extracted by mini-css-extract-plugin
export default {"pageLayout":"ib-z","mainContent":"jb-z","columnLayout":"kb-z","columnLayoutFill":"lb-z","columnLayoutLast":"mb-z"};